import React from 'react';

import { Heading } from 'shared-components';
import { PageTemplate, Header, Footer } from 'components';

const NotFoundPage = () => (
  <PageTemplate header={<Header />} footer={<Footer />}>
    <Heading>404 Not Found</Heading>
  </PageTemplate>
  );

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/pages/NotFoundPage/index.js